import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ProviderService } from '../../service/provider.service';
import { AuthState } from '../../store/authInfo/auth-state';
import { TechnicalAgreementComponent } from './technical-agreement/technical-agreement.component';

@Component({
  selector: 'app-provider-technical-agreement-manager',
  templateUrl: './provider-technical-agreement-manager.component.html',
  styleUrls: ['./provider-technical-agreement-manager.component.less']
})
export class ProviderTechnicalAgreementManagerComponent implements OnInit {

  @Input() pno: any; // 供应商编号
  pageIndex: number;
  pageSize: number;
  total = 0;
  loading = true;
  // 查询结果
  data = [];
  validateForm: FormGroup;
  authState = null;
  checked = false;
  indeterminate = false;
  setOfCheckedId = new Set<number>();
  constructor(
    private modalService: NzModalService,
    private message: NzMessageService,
    private providerService: ProviderService,
    private fb: FormBuilder,
    private store: Store,
  ) { }

  ngOnInit(): void {
    this.authState = this.store.selectSnapshot<any[]>(AuthState);
    this.validateForm = this.fb.group({
      taNo: [null], // 供应商名称
      taName: [null],
      pno: this.pno
    });
    this.queryTaData(1);
  }
  addTa(){
    const modal = this.modalService.create({
      nzTitle: '添加技术协议',
      nzContent: TechnicalAgreementComponent,
      nzStyle: { top: '20px' },
      nzBodyStyle: { paddingRight: '0px', paddingLeft: '42px' },
      nzWidth: 700,
      nzComponentParams: {
        code: 0, // 添加
        pno: this.pno
      },
      nzOnOk: (ev) => {
        const  form  = ev.getTaForm();
        const filePaths =  ev.getFilePathList();
        if (!this.validateFormData(form)){
          this.message.warning('数据未验证通过');
          return false;
        }else{
          const  ta = {
            taName : form.value.taName,
            taNo : form.value.taNo,
            aSigner: form.value.aSigner,
            aSignerPhone: form.value.aSignerPhone,
            bSigner: form.value.bSigner,
            bSignerPhone: form.value.bSignerPhone,
            signDate: form.value.signDate,
            taContent: form.value.taContent,
            mark: form.value.mark,
            createBy: this.authState.userInfo.userId,
            pno: form.value.pno,
            filePaths
          };
          // tslint:disable-next-line:no-shadowed-variable
          this.providerService.addTechnicalAgreement(ta).subscribe((data: any) => {
            if (!this.isEmpty(data)){
              this.queryTaData(1);
              this.message.success('添加成功');
              modal.close();
            }else{
              this.message.error('添加失败');
            }
          });
          return false;
        }
      },
      nzOnCancel: (ev) => {
      }
    });
  }
  viewTa(item){
    const modal = this.modalService.create({
      nzTitle: '查看技术协议',
      nzContent: TechnicalAgreementComponent,
      nzStyle: { top: '20px' },
      nzBodyStyle: { paddingRight: '0px', paddingLeft: '42px' },
      nzWidth: 700,
      nzComponentParams: {
        code: 2, // 查看
        pno: this.pno,
        taid: item.id // 供应商报价单id
      },
      nzOnOk: (ev) => {
      },
      nzOnCancel: (ev) => {
      }
    });
  }
  editTa(item){
    const modal = this.modalService.create({
      nzTitle: '修改技术协议',
      nzContent: TechnicalAgreementComponent,
      nzStyle: { top: '20px' },
      nzBodyStyle: { paddingRight: '0px', paddingLeft: '42px' },
      nzWidth: 700,
      nzComponentParams: {
        code: 1, // 编辑
        pno: this.pno,
        taid: item.id // 供应商技术协议id
      },
      nzOnOk: (ev) => {
        this.modalService.confirm({
          nzTitle: '修改技术协议',
          nzContent: '确定要修改技术协议内容？',
          nzOkText: '确定',
          nzCancelText: '取消',
          nzOnOk: () => {
            const  form  = ev.getTaForm();
            const filePaths =  ev.getFilePathList();
            if (!this.validateFormData(form)){
              this.message.warning('数据未验证通过');
            }else{
              const  qs = {
                id: item.id,
                taName : form.value.taName,
                taNo : form.value.taNo,
                taContent: form.value.taContent,
                aSigner: form.value.aSigner,
                aSignerPhone: form.value.aSignerPhone,
                bSigner: form.value.bSigner,
                bSignerPhone: form.value.bSignerPhone,
                signDate: form.value.signDate,
                mark: form.value.mark,
                updateBy: this.authState.userInfo.userId,
                pno: form.value.pno,
                filePaths
              };
              // tslint:disable-next-line:no-shadowed-variable
              this.providerService.updateTechnicalAgreement(qs).subscribe((data: any) => {
                if (!this.isEmpty(data)){
                  // this.queryContractData(1);
                  this.message.success('修改成功');
                  modal.close();
                }else{
                  this.message.error('修改失败');
                }
              });
            }
            return true;
          }
        });
        return false;
      },
      nzOnCancel: (ev) => {
      }
    });
  }
  onAllChecked(checked: boolean): void {
    this.data.forEach(item => this.updateCheckedSet(item.id, checked));
    this.refreshCheckedStatus();
  }

  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  refreshCheckedStatus(): void {
    this.checked = this.data.every(item => this.setOfCheckedId.has(item.id));
    this.indeterminate = this.data.some(item => this.setOfCheckedId.has(item.id)) && !this.checked;
  }
  onPageIndexChange(pageIndex) {
    this.pageIndex = pageIndex;
  }
  // 提交表单
  submitForm() {
    this.validateForm.setValue({
      taNo: this.validateForm.value.taNo,
      taName: this.validateForm.value.taName,
      pno: this.pno
    });
    this.queryTaData(1);
  }
  // 重置表单
  resetForm() {
    this.validateForm.setValue({
      taNo: null,
      taName: null,
      pno: this.pno
    });
    this.queryTaData(1);
  }
  queryTaData(flag: number) {
    if (flag === 1) {
      this.pageIndex = 1;
      this.pageSize = 10;
    }
    // tslint:disable-next-line:max-line-length
    this.providerService.getProviderTaByCondition(this.validateForm.value, this.pageIndex, this.pageSize).subscribe((data: any) => {
      this.loading = false;
      this.data = data.list;
      this.total = data.total;
    });
  }
  delete(){
    this.providerService.batchDeleteTas(this.setOfCheckedId).subscribe((data: any) => {
      if (data > 0){
        this.queryTaData(1);
      }
    });
  }
  public validateFormData(validateForm) {
    // tslint:disable-next-line:forin
    for (const i in validateForm.controls) {
      validateForm.controls[i].markAsDirty();
      validateForm.controls[i].updateValueAndValidity();
    }
    return validateForm.valid;
  }
  isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
